import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useLoggedInUserId } from "../../../../../src/features/auth/logic/rbac";
import { useAppSelector } from "../../../../../src/app/store";
import { selectParticipantByType } from "../../../../../src/features/caseinfo/logic/ParticipantsSlice";
import { ParticipantType } from "../../../../../src/api/participants";
import WorkflowStageBanner from "../../../../../src/features/stageWorkflow/components/WorkflowStageBanner";
import WorkflowStageInfoBanner from "../../../../../src/features/stageWorkflow/components/WorkflowStageInfoBanner";
import { NavigateButton } from "../../../../../src/components/ui/button/v2/NavigateButton";
import { selectCurrentCaseStage } from "../../../../../src/features/caseinfo/logic/Slice";
import { CaseRouteId, getCaseRoutePath } from "../../../../../src/features/caselayout/config/caseRoutes";

const IoAppAuthSubmitAssessmentStage: React.FC = () => {
  const navigate = useNavigate();
  const { id: caseId } = useParams<{ id: string }>();

  const loggedInUserId = useLoggedInUserId();

  const ioAppointingAuthorityParticipant = useAppSelector((state) =>
    selectParticipantByType(state, ParticipantType.IO_APPOINTING_AUTHORITY)
  );

  const ioAppointingAuthorityId =ioAppointingAuthorityParticipant?.participant_id;

  const isIOAppointingAuthority =loggedInUserId === ioAppointingAuthorityId;

  const currentStage = useAppSelector(selectCurrentCaseStage);
  const notes = currentStage?.stage_data?.notes;

  const handleNavigate = () => {
    if (!caseId) return;
    navigate(getCaseRoutePath(caseId, CaseRouteId.OBSERVATIONS_BY_AUTHORITY));
  };

  if (isIOAppointingAuthority) {
    return (
      <WorkflowStageBanner
        title="Review Investigation Report & Add Observations"
        description="Add Fraud/No Fraud recommendations, comments on investigation outcomes and ZFRC details, if applicable. After updating the details and uploading relevant documents, submit the report to forward the case to the FRMD."
        customActions={
          <NavigateButton
            label="Observations by Authority"
            onClick={handleNavigate}
          />
        }
        notes={notes}
      />
    );
  }

  return (
    <WorkflowStageInfoBanner
      title="Pending with IO Appointing Authority to Review Investigation Report & Add Observations"
    />
  );
};

export default IoAppAuthSubmitAssessmentStage;
